module.exports = __webpack_public_path__ + "img/sergievskaya.0a696081.jpg";